export const REFERRAL_COLORS = {
  bg: '#2B1E4A',
  glow: '#411F4A',
  cta: '#E11D48',
  
  success: '#31C48D',
  secondaryCircle: '#3A2E57',
  mutedText: '#A6A6B3',
  white: '#FFFFFF'
};
